// Prevent user from scrolling the background if a modal or overlay is opened.
let scrollPosition = 0;

export function preventScrollingInBackground() {
    const body = document.querySelector('body');
    body.style.overflow = 'hidden';

    // The following is a bugfix for Safari on iOS 12.
    scrollPosition = window.pageYOffset;
    body.style.position = 'fixed';
    body.style.top = `-${scrollPosition}px`;
    body.style.width = '100%';
}

// Enable scrolling again if a modal or overlay is closed.
export function enableScrollingInBackground() {
    const body = document.querySelector('body');
    body.style.removeProperty('overflow');

    // The following is a bugfix for Safari on iOS 12.
    body.style.removeProperty('position');
    body.style.removeProperty('top');
    body.style.removeProperty('width');
    window.scrollTo(0, scrollPosition);
}
